import { toast } from 'react-toastify';

import { setSuccess } from '../actions/loadingActions';
import { logout, saveLoginDetails } from '../actions/loginActions';
import { LOCAL_STORAGE_KEY } from '../constants/generals';
import { IHistory } from '../interfaces';
import { UserModel } from '../model/UserModel';
import { postDev } from '../utils/HTTPDev';

export async function loginUser(UserId, Password, history, pathName) {
    try {
        const response = await postDev('login', {
            UserId: parseInt(UserId), Password
        });
        setSuccess('LoginButton');
        const userData = parseJwt(response.data.token);
        saveUserData(response.data.token || '', UserId, userData.UniqueId);
        userData.id = userData.UniqueId;
        new UserModel(userData).$save();
        saveLoginDetails({ token: response.data.token, UniqueId: userData.UniqueId });
        history.push(pathName);
    } catch (error) {
        toast.error(error.toString().split(':')[1], {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        setSuccess('LoginButton');
        throw error;
    }
}
export function checkForUserExpiry(userData) {
    
    const expiryDate = userData && parseJwt(userData.token);
    if ( expiryDate && (Date.now() > Number(`${expiryDate.exp}000`))) {
        removeUserData();
        document.location.href = '/';
        return true;
     }
    return false;
}

export function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
}

export function logoutUser(history: IHistory) {
    removeUserData();
    logout(); 
    history && history.push('/');
}

export function saveUserData(token, userId, UniqueId) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        token, userId, isLoggedIn: true, UniqueId
    }));
}

export function getUserData() {
    return JSON.parse(localStorage.getItem('EnviroConnectUserInfo'));
}

export function removeUserData() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/loginService.ts